import { messageFilterFun, roleOrganization } from '@/controllers/API/assistant'
import { Checkbox, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import '../ChatSendInput.less'

import { generateUUIDv4 } from '@/util/utils'
import { areAllLeafUsersChecked, generateTree, getAllLeafUsers, hasAnyCheckedDescendant } from './ChatSendFun'

/**
 * MentionSuggestions 组件
 * 用于展示输入 `@` 后弹出的建议列表
 */
interface MentionSuggestionsProps {
  menuPosition: { top: number; left: number } // 弹出菜单的位置
  suggestionRefs: React.MutableRefObject<any[]> // 每个建议项的 ref（用于键盘导航时定位）
  isKeyboardNavigating: boolean // 是否通过键盘在列表中导航
  insertSuggestion: (item: string | Object | any) => void // 插入建议的方法
  setIsKeyboardNavigating: (val: boolean) => void // 设置是否键盘导航
  searchName?: string
  resetFun?: any
}

const MentionSuggestions: React.FC<MentionSuggestionsProps> = ({
  menuPosition,
  suggestionRefs,
  isKeyboardNavigating,
  insertSuggestion,
  setIsKeyboardNavigating,
  searchName = '',
  resetFun
}) => {
  /* 全部数据 */
  let [list, setList] = useState([])
  /* 选中当前显示层级数据 */
  let [atlist, setAtList] = useState([])
  /* 总数 */
  let [total, setTotal] = useState(0)
  let [loading, setLoading] = useState(true)
  /* 筛选数据list - 每层 */
  let [filterList, setFilterList] = useState([])
  /* 多选-list */
  let [checkList, setCheckList] = useState([])
  /* 区分单选多选 */
  let [ChooseType, setChooseType] = useState('radio')
  /* 新添加的状态 */
  const [selectedItems, setSelectedItems] = useState<any[]>([])
  /* 新添加的状态 */
  const [selectedIndex, setSelectedIndex] = useState(-1)
  /* 新添加的状态 */
  const [isKeyboardMode, setIsKeyboardMode] = useState(false)
  /* 添加鼠标悬停项目的状态 */
  const [hoverIndex, setHoverIndex] = useState(-1)

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      await getInfo(searchName)
    }
    init()
  }, [searchName])

  let getInfo = (name = '') => {
    /* 重置状态（搜索） */
    setList([])
    setTotal(0)
    setAtList([])
    setCheckList([])
    setChooseType('radio')
    setFilterList([])
    /* name存在搜索人员 不存在全员列表-剔除第一项公司 */
    const fetchData = name ? messageFilterFun : () => roleOrganization('', false)
    fetchData(name)
      .then(res => {
        const { treeData, totalUsers } = generateTree(res)
        setTotal(totalUsers)
        setList(treeData)
        setAtList(treeData)
        setLoading(false)
        if (!treeData || treeData?.length === 0) {
          onErrFun()
        }
      })
      .catch(err => {
        console.log(err)
        onErrFun()
      })
      .finally(() => {
        setLoading(false)
      })
  }
  /* 搜索无结果 or 没数据 */
  let onErrFun = () => {
    resetFun()
  }

  /* 点击事件 - 切换数据 */
  let sendCaseSwitchFun = e => {
    if (e?.children && e?.children?.length > 0) {
      setAtList(e.children)
      // 判断 filterList 中是否已经有 e
      const exists = filterList.some(item => item.key === e.key)
      if (!exists) {
        setFilterList([...filterList, e])
      }
      return
    }
    if (ChooseType === 'radio') {
      /* 单选逻辑 */
      if (!e.children) {
        insertSuggestion(e)
        setIsKeyboardNavigating(false)
        resetFun()
      }
    } else {
      /* 多选逻辑 */
      if (!e.children) {
        setSelectedItems(prev => {
          const isAlreadySelected = prev.some(item => item.key === e.key)
          if (isAlreadySelected) {
            return prev.filter(item => item.key !== e.key)
          } else {
            return [...prev, e]
          }
        })
      }
    }
  }

  /* svg */
  let allSvg = () => {
    return (
      <svg
        className="mr-[8px]"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="14" fill="#5964F3" />
        <path
          d="M12.0557 14.1904C13.3995 14.1905 14.641 14.5164 15.5625 15.0693C16.4738 15.6163 17.1512 16.4417 17.1514 17.4473C17.1513 18.4531 16.4739 19.2792 15.5625 19.8262C14.641 20.3791 13.3995 20.705 12.0557 20.7051C10.7119 20.7051 9.47046 20.379 8.54883 19.8262C7.63714 19.2792 6.96002 18.4532 6.95996 17.4473C6.96016 16.4414 7.63724 15.6163 8.54883 15.0693C9.47047 14.5164 10.7118 14.1904 12.0557 14.1904ZM17.8896 14.6611L18.208 14.7383C18.9405 14.9353 19.5901 15.2452 20.083 15.6484C20.6458 16.109 21.0399 16.7262 21.04 17.4473C21.04 18.1682 20.6456 18.7845 20.083 19.2451C19.5198 19.706 18.7521 20.0457 17.8896 20.2334L17.7891 20.2451C17.5566 20.2481 17.3465 20.0875 17.2949 19.8516C17.2365 19.5819 17.4071 19.3146 17.6768 19.2559L17.9512 19.1895C18.5752 19.0213 19.0883 18.767 19.4492 18.4717C19.8619 18.1339 20.04 17.7765 20.04 17.4473C20.0399 17.1181 19.8619 16.7606 19.4492 16.4229C19.0883 16.1276 18.5752 15.8732 17.9512 15.7051L17.6768 15.6377L17.5811 15.6064C17.3682 15.5125 17.2435 15.2791 17.2949 15.043C17.3465 14.8071 17.5566 14.6464 17.7891 14.6494L17.8896 14.6611ZM12.0557 15.1904C10.862 15.1904 9.80501 15.482 9.06348 15.9268C8.31219 16.3775 7.96016 16.9306 7.95996 17.4473C7.96002 17.964 8.31204 18.5179 9.06348 18.9688C9.805 19.4135 10.862 19.7051 12.0557 19.7051C13.2494 19.705 14.3064 19.4136 15.0479 18.9688C15.7991 18.5179 16.1513 17.9639 16.1514 17.4473C16.1512 16.9307 15.7988 16.3775 15.0479 15.9268C14.3064 15.4819 13.2494 15.1905 12.0557 15.1904ZM12.0547 7.29688C13.8534 7.29694 15.3121 8.75512 15.3125 10.5537C15.3125 12.3526 13.8536 13.8115 12.0547 13.8115C10.2559 13.8113 8.79785 12.3525 8.79785 10.5537C8.79821 8.75522 10.2562 7.29711 12.0547 7.29688ZM16.4043 8.21582C17.9493 8.21582 19.2019 9.4687 19.2021 11.0137C19.2021 12.5588 17.9494 13.8115 16.4043 13.8115C16.1283 13.8114 15.9044 13.5875 15.9043 13.3115C15.9045 13.0356 16.1284 12.8117 16.4043 12.8115C17.3971 12.8115 18.2021 12.0065 18.2021 11.0137C18.2019 10.021 17.397 9.21582 16.4043 9.21582C16.1283 9.21569 15.9043 8.99188 15.9043 8.71582C15.9045 8.43993 16.1284 8.21595 16.4043 8.21582ZM12.0547 8.29688C10.8085 8.29711 9.79821 9.30751 9.79785 10.5537C9.79785 11.8002 10.8082 12.8113 12.0547 12.8115C13.3013 12.8115 14.3125 11.8003 14.3125 10.5537C14.3121 9.3074 13.3011 8.29694 12.0547 8.29688Z"
          fill="white"
        />
      </svg>
    )
  }
  let DepartmentSvg = () => {
    return (
      <svg className="mx-[8px]" width="1" height="14" viewBox="0 0 1 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="1" height="14" fill="#DDE3F2" />
      </svg>
    )
  }

  /* 添加滚动到选中项的方法 */
  const scrollToSelected = (index: number) => {
    const element = suggestionRefs.current[index]
    if (element) {
      element.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      })
    }
  }

  /* 修改键盘事件处理函数 */
  const handleKeyDown = (e: React.KeyboardEvent) => {
    // 处理上下箭头键导航
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault()
      setIsKeyboardMode(true) // 进入键盘导航模式
      setSelectedIndex(prev => {
        const nextIndex = e.key === 'ArrowDown' ? prev + 1 : prev - 1
        const newIndex = nextIndex >= atlist.length ? 0 : nextIndex < 0 ? atlist.length - 1 : nextIndex
        scrollToSelected(newIndex)
        return newIndex
      })
    } else if (e.key === 'Enter') {
      e.preventDefault()
      // 只使用键盘选中的项目，忽略鼠标悬停状态
      if (selectedIndex !== -1) {
        const selectedItem = atlist[selectedIndex]
        if (!selectedItem) return

        if (selectedItem.children && selectedItem.children.length > 0) {
          sendCaseSwitchFun(selectedItem)
          setSelectedIndex(-1)
          setHoverIndex(-1)
          return
        }

        if (ChooseType === 'radio') {
          insertSuggestion(selectedItem)
          resetFun()
        } else {
          setSelectedItems(prev => {
            const isAlreadySelected = prev.some(item => item.key === selectedItem.key)
            if (isAlreadySelected) {
              return prev.filter(item => item.key !== selectedItem.key)
            } else {
              return [...prev, selectedItem]
            }
          })
        }
      }
    } else if (e.key === 'Escape') {
      e.preventDefault()
      resetFun()
    }
  }

  // 添加鼠标事件处理
  const handleMouseEnter = (index: number) => {
    if (!isKeyboardMode) {
      setHoverIndex(index)
    }
  }

  // 添加鼠标移动事件处理
  const handleMouseMove = () => {
    setIsKeyboardMode(false)
  }

  // 添加鼠标离开事件处理
  const handleMouseLeave = () => {
    if (!isKeyboardMode) {
      setHoverIndex(-1)
    }
  }

  /* 添加处理所有人选择的方法 */
  const handleAllPeopleSelect = () => {
    if (searchName) {
      // 如果是搜索状态，传递所有匹配的用户数据
      const allUsers = getAllLeafUsers({ children: atlist })
      insertSuggestion(allUsers)
    } else {
      // 如果不是搜索状态，传递所有人标识
      insertSuggestion({
        title: '所有人',
        key: 'all',
        id: 'all'
      })
    }
    resetFun()
  }

  // 渲染所有人选项
  const renderAllPeopleOption = () => (
    <div className="flexRowStart sendCaseItem cursonCase" onClick={handleAllPeopleSelect}>
      {allSvg()}
      {searchName ? '以下所有人' : '所有人'}({total})
    </div>
  )

  return (
    <div
      style={{ top: `${menuPosition.top - 300}px`, left: `${menuPosition.left}px` }}
      className="sendCase flexCol"
      onKeyDown={handleKeyDown}
      onMouseMove={handleMouseMove}
      tabIndex={0}
    >
      {loading ? (
        <Spin spinning={loading} className="h-full w-full">
          <div className="h-[300px] w-full"></div>
        </Spin>
      ) : (
        <div className="flexCol caseOverFlowY h-full">
          {/* 非搜索状态下的所有人选项 */}
          {!searchName && renderAllPeopleOption()}
          {/* 功能框 部门级别 */}
          <div className="mb-[4px] h-[28px] w-full p-[8px]">
            <div className="flexRowJustBet sendCaseHierarchy flexRowStart w-full">
              {/* 层级显示 */}
              {filterList.length > 0 ? (
                <div className={`flexRowStart ${ChooseType === 'radio' ? 'w-[80%]' : 'w-[45%]'} `}>
                  {filterList.length > 0 && (
                    <svg
                      className="cursonCase mr-[4px]"
                      onClick={() => {
                        if (filterList.length === 1) {
                          // 返回顶层时，使用完整的list
                          setAtList(list)
                          setFilterList([])
                        } else {
                          const newList = filterList.slice(0, filterList.length - 1)
                          setFilterList(newList)
                          // 使用父级的完整子项列表
                          const parentItem = newList[newList.length - 1]
                          if (parentItem) {
                            setAtList(parentItem.children)
                          } else {
                            setAtList(list)
                          }
                        }
                      }}
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.5 9.5L4.5 6.5L7.5 3.5"
                        stroke="#69798F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                  <span className="domOverflowEllip w-[calc(100%-20px)]">
                    {filterList[filterList.length - 1].title}
                  </span>
                </div>
              ) : (
                <span>{!searchName ? '组织部门' : '搜索结果'}</span>
              )}
              {/* 按钮显示 */}
              {ChooseType === 'radio' ? (
                <span
                  className="sendCaseHierarchy cursonCase text-[#062FF8]"
                  onClick={() => {
                    setChooseType('check')
                    setSelectedItems([])
                  }}
                >
                  多选
                </span>
              ) : (
                <div className="flexRowStart sendCaseHierarchy text-[#062FF8]">
                  <span
                    onClick={() => {
                      setSelectedItems([])
                      setChooseType('radio')
                    }}
                    className="cursonCase"
                  >
                    退出多选
                  </span>
                  {DepartmentSvg()}
                  <span
                    onClick={() => {
                      if (selectedItems.length > 0) {
                        insertSuggestion(selectedItems)
                        resetFun()
                      }
                    }}
                    className="cursonCase"
                  >
                    完成 ({selectedItems.length})
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* 搜索状态下的所有人选项 */}
          {searchName && renderAllPeopleOption()}
          {/* 循环显示列表 */}
          <div className="caseOverFlowY flexCol h-[calc(100%-60px)]">
            {atlist.map((item, index) => {
              return (
                <div
                  key={item.key + generateUUIDv4()}
                  ref={el => (suggestionRefs.current[index] = el)}
                  className={`flexRowStart sendCaseItem flexRowJustBet ${
                    item?.children && item?.children?.length === 0 ? 'cursor-not-allowed text-[#ccc]' : 'cursonCase'
                  } ${index === selectedIndex ? 'highlight' : ''} ${
                    !isKeyboardMode && index === hoverIndex ? 'cursonCase' : ''
                  }`}
                  onClick={() => {
                    setSelectedIndex(index)
                    sendCaseSwitchFun(item)
                  }}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                >
                  <span className="flexRowStart">
                    {/* 多选check */}
                    {ChooseType === 'check' && (
                      <div
                        className="call-dialog-checkbox mr-[8px]"
                        onClick={e => {
                          e.stopPropagation()
                        }}
                      >
                        <Checkbox
                          onChange={e => {
                            const checked = e.target.checked
                            const leafUsers = getAllLeafUsers(item)

                            if (checked) {
                              const merged = [...selectedItems]
                              leafUsers.forEach(user => {
                                if (!merged.some(i => i.key === user.key)) {
                                  merged.push(user)
                                }
                              })
                              setSelectedItems(merged)
                            } else {
                              const filtered = selectedItems.filter(i => !leafUsers.some(u => u.key === i.key))
                              setSelectedItems(filtered)
                            }
                          }}
                          disabled={item?.children && item.children.length === 0}
                          checked={
                            !item.children || item.children.length === 0
                              ? selectedItems.some(i => i.key === item.key)
                              : areAllLeafUsersChecked(item, selectedItems)
                          }
                          indeterminate={
                            hasAnyCheckedDescendant(item, selectedItems) &&
                            !areAllLeafUsersChecked(item, selectedItems) &&
                            Array.isArray(item.children) &&
                            item.children.length > 0
                          }
                        />
                      </div>
                    )}
                    {/* 头像
                    部门-默认svg
                    人员-判断avatart 存在显示 不存在显示名称第一个字
                    */}
                    {item.children ? (
                      <svg
                        className="mr-[8px]"
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="28" height="28" rx="14" fill="#5964F3" />
                        <path
                          d="M11.375 6.625C12.2034 6.625 12.875 7.29657 12.875 8.125V9.625C12.875 10.4534 12.2034 11.125 11.375 11.125H10.625V13.375H14.375C14.375 12.5466 15.0466 11.875 15.875 11.875H18.875C19.7034 11.875 20.375 12.5466 20.375 13.375V14.375C20.375 15.2034 19.7034 15.875 18.875 15.875H15.875C15.0466 15.875 14.375 15.2034 14.375 14.375H10.625V16.875C10.625 17.7034 11.2966 18.375 12.125 18.375H14.7119C14.918 17.7927 15.4721 17.375 16.125 17.375H19.125C19.9534 17.375 20.625 18.0466 20.625 18.875V19.875C20.625 20.7034 19.9534 21.375 19.125 21.375H16.125C15.2966 21.375 14.625 20.7034 14.625 19.875V19.375H12.125C10.7443 19.375 9.625 18.2557 9.625 16.875V11.125H8.875C8.09834 11.125 7.45961 10.5347 7.38281 9.77832L7.375 9.625V8.125C7.375 7.29657 8.04657 6.625 8.875 6.625H11.375ZM16.125 18.375C15.8489 18.375 15.625 18.5989 15.625 18.875V19.875C15.625 20.1511 15.8489 20.375 16.125 20.375H19.125C19.4011 20.375 19.625 20.1511 19.625 19.875V18.875C19.625 18.5989 19.4011 18.375 19.125 18.375H16.125ZM15.875 12.875C15.5989 12.875 15.375 13.0989 15.375 13.375V14.375C15.375 14.6511 15.5989 14.875 15.875 14.875H18.875C19.1511 14.875 19.375 14.6511 19.375 14.375V13.375C19.375 13.0989 19.1511 12.875 18.875 12.875H15.875ZM8.875 7.625C8.59886 7.625 8.375 7.84886 8.375 8.125V9.625L8.38477 9.72559C8.43129 9.95355 8.63329 10.125 8.875 10.125H11.375C11.6511 10.125 11.875 9.90114 11.875 9.625V8.125C11.875 7.84886 11.6511 7.625 11.375 7.625H8.875Z"
                          fill="white"
                        />
                      </svg>
                    ) : item?.avatar ? (
                      <img className="mr-[8px] h-[28px] w-[28px] rounded-[14px]" src={item.avatar} alt="头像" />
                    ) : (
                      <span className="nameCase flexRow mr-[8px] h-[28px] w-[28px] rounded-[14px] bg-[#9659F2]">
                        {item.title.slice(0, 1)}
                      </span>
                    )}
                    {/* 名称 */}
                    {item.title}
                  </span>
                  {/* 带children - 下一级icon */}
                  {item?.children && (
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_2626_86192)">
                        <path
                          d="M8.29289 5.29289L4.70711 1.70711C4.07714 1.07714 3 1.52331 3 2.41421L3 9.58579C3 10.4767 4.07714 10.9229 4.70711 10.2929L8.29289 6.70711C8.68342 6.31658 8.68342 5.68342 8.29289 5.29289Z"
                          fill="#69798F"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2626_86192">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default MentionSuggestions
